<template>
  <h2 :class="b('', {
    mix: className,
    isSmall,
    isMini,
    isLeft,
    isWhite,
    isMobileView,
  })">
    <!-- Режим редактирования -->
    <a-input
      v-if="isEdit"
      :class="b('text-input')"
      placeholder="Enter title text"
      v-model:value="editableText"
      @input="updateText"
    />
    <!-- Обычный режим -->
    <span v-else>
      <slot />
    </span>
  </h2>
</template>

<script>
import bem from '@/utils/bem';
import styles from './title-block-style.scss';

const b = bem('title-block', styles);

export default {
  name: 'TitleBlock',
  props: {
    className: {
      type: String,
      default: '',
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    isMini: {
      type: Boolean,
      default: false,
    },
    isLeft: {
      type: Boolean,
      default: false,
    },
    isWhite: {
      type: Boolean,
      default: false,
    },
    isMobileView: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    editText: {
      type: String,
      default: '',
    },
  },
  computed: {
    b() {
      return b;
    },
    editableText: {
      get() {
        return this.editText;
      },
      set(value) {
        this.$emit('update-text', value);
      },
    },
  },
  methods: {
    updateText(event) {
      this.$emit('update-text', event.target.value);
    },
  },
};
</script>
